import { BackendError } from './base';
import General from './general';

class OrderAlreadyExists extends BackendError {}
class CouldNotCreateTransaction extends BackendError {}
class TransactionPaymentFailed extends BackendError {}
class InsufficientPoints extends BackendError {}
class CouldNotSavePspReturn extends BackendError {}
class PointOrderDoesNotExist extends General.NotFound {}

export default {
    OrderAlreadyExists,
    CouldNotCreateTransaction,
    TransactionPaymentFailed,
    InsufficientPoints,
    CouldNotSavePspReturn,
    PointOrderDoesNotExist,
};
